import { Component, type ReactNode, type ErrorInfo } from 'react';
import { Button } from './Button';
import { getTranslation } from '../../i18n';
import styles from './ErrorBoundary.module.css';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      const t = getTranslation;
      return (
        <div className={styles.container}>
          <div className={styles.card}>
            <h1 className={styles.title}>{t('error.title')}</h1>
            <p className={styles.message}>
              {t('error.message')}
            </p>
            {this.state.error && (
              <div className={styles.details}>
                {this.state.error.message}
              </div>
            )}
            <Button onClick={this.handleReset}>
              {t('error.returnHome')}
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
